import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  FLEX_DIRECTION,
  ACCORDION_LAYOUT
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  colorTheme: 'LIGHT' | 'DARK',
  items: {
    title: string,
    description: string,
    descriptionBottom: boolean,
    direction: typeof FLEX_DIRECTION[number],
    layout: typeof ACCORDION_LAYOUT[number],
    image?: string,
    video?: string
  }[]
}

const propsSchema: PropsSchemaList = [
  {
    key: 'items',
    label: 'Accordion Items',
    type: types.ARRAY,
    options: {
      maxLength: 8
    },
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
        options: {
          maxLength: 60
        }
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
        options: {
          maxLength: 300
        }
      },
      {
        key: 'descriptionBottom',
        label: 'Show description on the bottom/right',
        type: types.BOOLEAN,
      },
      {
        key: 'direction',
        label: 'Content layout direction',
        type: types.ENUM,
        options: FLEX_DIRECTION,
      },
      {
        key: 'layout',
        label: 'Content layout proportions (ROW only)',
        type: types.ENUM,
        options: ACCORDION_LAYOUT,
      },
      {
        key: 'image',
        label: 'Image',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'video',
        label: 'Video',
        type: types.S3_ASSET_URL,
      },
    ],
  },
  {
    key: 'colorTheme',
    label: 'Theme (text color only)',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
];

const defaultProps: Props = {
  colorTheme: 'LIGHT',
  items: [{
    title: 'Digitally-Immersed Living Space',
    description: 'FF 91 provides a modern luxury living space united with continuous and vibrant connectivity to the digital world. Users exist in a world of screens that allow them to be in their home, their office and with their friends, all at the same time.',
    descriptionBottom: false,
    direction: 'ROW',
    layout: '50%/50%',
    image: 'https://genesis-cdn.ff.com/FF-NVIDIA--2--default.jpg',
    video: '',
  }, {
    title: 'Digitally-Immersed Living Space',
    description: 'FF 91 provides a modern luxury living space united with continuous and vibrant connectivity to the digital world. Users exist in a world of screens that allow them to be in their home, their office and with their friends, all at the same time.',
    descriptionBottom: false,
    direction: 'ROW',
    layout: '50%/50%',
    image: 'https://genesis-cdn.ff.com/FF-NVIDIA--2--default.jpg',
    video: '',
  }, {
    title: 'Digitally-Immersed Living Space',
    description: 'FF 91 provides a modern luxury living space united with continuous and vibrant connectivity to the digital world. Users exist in a world of screens that allow them to be in their home, their office and with their friends, all at the same time.',
    descriptionBottom: false,
    direction: 'ROW',
    layout: '50%/50%',
    image: '',
    video: 'https://genesis-cdn.ff.com/assets/pages/homepage/born-in-ca/GlobalDNA_KV_An06B_1x1_MapWOcityDots.mp4',
  }],
};

export default {
  title: 'Accordion',
  id: 'Accordion',
  propsSchema,
  defaultProps,
};
